'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, stage_id) {
  return function (dispatch, getState) {
    var cache = (0, _paths.getEventsOnStage)(getState(), stage_id);

    // prefer the cached version
    if (cache) return Promise.resolve();

    return dispatch(_defineProperty({
      feis_id: feis_id,
      stage_id: stage_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisStagesPrefix)(feis_id) + '/' + stage_id + '/schedule'
      },
      types: ['GET_EVENTS_FOR_STAGE_START', 'GET_EVENTS_FOR_STAGE', 'GET_EVENTS_FOR_STAGE_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/getEventsForStage.js
// module id = 159
// module chunks = 0